import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'sim',
    loadComponent: () => import('./sim/simulator-page').then((m) => m.SimulatorPage),
  },
  {
    path: '**',
    loadComponent: () => import('./shell/pane-root').then((m) => m.PaneRoot),
  },
];
